export default __webpack_public_path__ + "static/media/unhrcLogo.5021d8e7.png";